import { getLabelMessage } from '@gef-ui/localization/messages';
import join from "ramda/es/join";
import map from "ramda/es/map";
import o from "ramda/es/o";
export const cleanTimestamp = (isoTimestamp)=>isoTimestamp.replaceAll(/[TZ]/gi, ' ');
const versionObjectToString = ({ name, version })=>`${name}: ${version.trim()}`;
export const joinVersions = o(join(', '), map(versionObjectToString));
// copied from packages/delegations/src/utils/index.js
export const getRepresentativeUser = ()=>{
    const representativeFor = window.sessionStorage.getItem('representativeFor');
    if (representativeFor) {
        return {
            representativeFor
        };
    } else {
        return {};
    }
};
export const getHelpdeskErrorObject = (feVersions = [], beVersions = [], error, userArg, generatedTimestamp)=>{
    const { screen, traceId, timestamp: errorTimestamp, user = userArg, shortDescription, longDescription, heading } = error;
    const resolvedTimestamp = errorTimestamp ?? generatedTimestamp;
    return {
        application: [
            screen,
            joinVersions(feVersions),
            joinVersions(beVersions),
            cleanTimestamp(resolvedTimestamp)
        ].filter((a)=>a).join(', ').trim(),
        traceId,
        description: `${heading}, ${shortDescription}, ${longDescription}`,
        user,
        ...getRepresentativeUser()
    };
};
export const getErrorMessage = (feVersions, beVersions, error, userArg, generatedTimestamp)=>{
    const { application, traceId, description, user, representativeFor } = getHelpdeskErrorObject(feVersions, beVersions, error, userArg, generatedTimestamp);
    return `${getLabelMessage('common:application')}: ${application}
${getLabelMessage('errors:uniqueIdentifier')}: ${traceId ?? 'N/A'}
${getLabelMessage('errors:errorDescription')}: ${description}
${getLabelMessage('common:user')}: ${user ?? 'N/A'}
${getLabelMessage('delegations:inDelegations')}: ${representativeFor ?? 'N/A'}`;
};
export const getErrorsMessages = (feVersion, beVersion, errors, user, generatedTimestamp)=>{
    let message = '';
    for(let i = 0; i < errors.length; i++){
        message += getErrorMessage(feVersion, beVersion, errors[i], user, generatedTimestamp);
        if (i !== errors.length - 1) {
            message += '\n------------------------------------\n';
        }
    }
    return message;
};
